import { render, staticRenderFns } from "./KnowhowBlock.vue?vue&type=template&id=66e32bb1"
import script from "./KnowhowBlock.vue?vue&type=script&lang=js"
export * from "./KnowhowBlock.vue?vue&type=script&lang=js"
import style0 from "./KnowhowBlock.vue?vue&type=style&index=0&id=66e32bb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports